webpackJsonp([47,45],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(171);
	module.exports = __webpack_require__(466);


/***/ }),

/***/ 415:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'App'
	};

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var pageSize = 10;
	var cycleTime = [{ 'value': 1, 'label': '00:00 AM' }, { 'value': 2, 'label': '01:00 AM' }, { 'value': 3, 'label': '02:00 AM' }, { 'value': 4, 'label': '03:00 AM' }, { 'value': 5, 'label': '04:00 AM' }, { 'value': 6, 'label': '05:00 AM' }, { 'value': 7, 'label': '06:00 AM' }, { 'value': 8, 'label': '07:00 AM' }, { 'value': 9, 'label': '08:00 AM' }, { 'value': 10, 'label': '09:00 AM' }, { 'value': 11, 'label': '10:00 AM' }, { 'value': 12, 'label': '11:00 AM' }, { 'value': 13, 'label': '12:00 PM' }, { 'value': 14, 'label': '01:00 PM' }, { 'value': 15, 'label': '02:00 PM' }, { 'value': 16, 'label': '03:00 PM' }, { 'value': 17, 'label': '04:00 PM' }, { 'value': 18, 'label': '05:00 PM' }, { 'value': 19, 'label': '06:00 PM' }, { 'value': 20, 'label': '07:00 PM' }, { 'value': 21, 'label': '08:00 PM' }, { 'value': 22, 'label': '09:00 PM' }, { 'value': 23, 'label': '10:00 PM' }, { 'value': 24, 'label': '11:00 PM' }];
	
	exports.default = {
	  pageSize: pageSize,
	  cycleTime: cycleTime
	};

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(6);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		LStorage: {
			getItem: function getItem(key) {
				try {
					return JSON.parse(window.localStorage.getItem(key));
				} catch (err) {
					return null;
				}
			},
			setItem: function setItem(key, val) {
				window.localStorage.setItem(key, (0, _stringify2.default)(val));
			},
			clear: function clear() {
				window.localStorage.clear();
			},
			keys: function keys() {
				return window.localStorage.keys();
			},
			removeItem: function removeItem(key) {
				window.localStorage.removeItem(key);
			}
		},
		SStorage: {
			getItem: function getItem(key) {
				try {
					return JSON.parse(window.sessionStorage.getItem(key));
				} catch (err) {
					return null;
				}
			},
			setItem: function setItem(key, val) {
				window.sessionStorage.setItem(key, (0, _stringify2.default)(val));
			},
			clear: function clear() {
				window.sessionStorage.clear();
			},
			keys: function keys() {
				return window.sessionStorage.keys();
			},
			removeItem: function removeItem(key) {
				window.sessionStorage.removeItem(key);
			}
		},
		base64ToData: function base64ToData(apiData) {
			var base_to_json = Base64.decode(apiData);
			return base_to_json;
		},
	
		DataToBase64: function DataToBase64(apiParm) {
			var par_to_base = Base64.encode(apiParm);
			return par_to_base;
		},
		isPhone: function isPhone(inputVal) {
			var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
			if (!myreg.test(inputVal)) {
				return false;
			} else {
				return true;
			}
		},
		sortStr: function sortStr(str) {
			var upper = { "a": "A", "b": "B", "c": "C", "d": "D", "e": "E", "f": "F", "g": "G", "h": "H",
				"i": "I", "j": "J", "k": "K", "l": "L", "m": "M", "n": "N", "o": "O", "p": "P", "q": "Q",
				"r": "R", "s": "S", "t": "T", "u": "U", "v": "V", "w": "W", "x": "X", "y": "Y", "z": "Z" };
			for (var i in str) {
				for (var j in upper) {
					if (str[i] === upper[j]) {
						if (str != 'weeklyAverage') {
							str = str.replace(str[i], '_' + j);
						}
					}
				}
			}
			return str;
		},
		getTimeArea: function getTimeArea() {
			return new Date().getTimezoneOffset() / 60;
		},
		formatCycleTime: function formatCycleTime(timeName) {
			if (timeName == '00:00') timeName = '00:00 AM';
			if (timeName == '01:00') timeName = '01:00 AM';
			if (timeName == '02:00') timeName = '02:00 AM';
			if (timeName == '03:00') timeName = '03:00 AM';
			if (timeName == '04:00') timeName = '04:00 AM';
			if (timeName == '05:00') timeName = '05:00 AM';
			if (timeName == '06:00') timeName = '06:00 AM';
			if (timeName == '07:00') timeName = '07:00 AM';
			if (timeName == '08:00') timeName = '08:00 AM';
			if (timeName == '09:00') timeName = '09:00 AM';
			if (timeName == '10:00') timeName = '10:00 AM';
			if (timeName == '11:00') timeName = '11:00 AM';
			if (timeName == '12:00') timeName = '12:00 PM';
			if (timeName == '13:00') timeName = '01:00 PM';
			if (timeName == '14:00') timeName = '02:00 PM';
			if (timeName == '15:00') timeName = '03:00 PM';
			if (timeName == '16:00') timeName = '04:00 PM';
			if (timeName == '17:00') timeName = '05:00 PM';
			if (timeName == '18:00') timeName = '06:00 PM';
			if (timeName == '19:00') timeName = '07:00 PM';
			if (timeName == '20:00') timeName = '08:00 PM';
			if (timeName == '21:00') timeName = '09:00 PM';
			if (timeName == '22:00') timeName = '10:00 PM';
			if (timeName == '23:00') timeName = '11:00 PM';
			return timeName;
		},
		toDecimal: function toDecimal(x) {
			var f = parseFloat(x);
			if (isNaN(f)) {
				return false;
			}
			var f = Math.round(x * 100) / 100;
			var s = f.toString();
			var rs = s.indexOf('.');
			if (rs < 0) {
				rs = s.length;
				s += '.';
			}
			while (s.length <= rs + 2) {
				s += '0';
			}
			return s;
		},
		getDifference: function getDifference() {
			var difference = 0;
	
			var userInfo = JSON.parse(window.localStorage.getItem("userInfo")).store;
			if (userInfo) {
				difference = userInfo.difference;
			} else {
				difference = 0;
			}
			return difference;
		}
	};

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(72);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Print = function Print(dom, options) {
	  if (!(this instanceof Print)) return new Print(dom, options);
	
	  this.options = this.extend({
	    'noPrint': '.no-print'
	  }, options);
	
	  if (typeof dom === "string") {
	    this.dom = document.querySelector(dom);
	  } else {
	    this.isDOM(dom);
	    this.dom = this.isDOM(dom) ? dom : dom.$el;
	  }
	
	  this.init();
	};
	Print.prototype = {
	  init: function init() {
	    var content = this.getStyle() + this.getHtml();
	    this.writeIframe(content);
	  },
	  extend: function extend(obj, obj2) {
	    for (var k in obj2) {
	      obj[k] = obj2[k];
	    }
	    return obj;
	  },
	
	  getStyle: function getStyle() {
	    var str = "",
	        styles = document.querySelectorAll('style,link');
	    for (var i = 0; i < styles.length; i++) {
	      str += styles[i].outerHTML;
	    }
	    str += "<style>" + (this.options.noPrint ? this.options.noPrint : '.no-print') + "{display:none;}</style>";
	
	    return str;
	  },
	
	  getHtml: function getHtml() {
	    var inputs = document.querySelectorAll('input');
	    var textareas = document.querySelectorAll('textarea');
	    var selects = document.querySelectorAll('select');
	
	    for (var k = 0; k < inputs.length; k++) {
	      if (inputs[k].type == "checkbox" || inputs[k].type == "radio") {
	        if (inputs[k].checked == true) {
	          inputs[k].setAttribute('checked', "checked");
	        } else {
	          inputs[k].removeAttribute('checked');
	        }
	      } else if (inputs[k].type == "text") {
	        inputs[k].setAttribute('value', inputs[k].value);
	      } else {
	        inputs[k].setAttribute('value', inputs[k].value);
	      }
	    }
	
	    for (var k2 = 0; k2 < textareas.length; k2++) {
	      if (textareas[k2].type == 'textarea') {
	        textareas[k2].innerHTML = textareas[k2].value;
	      }
	    }
	
	    for (var k3 = 0; k3 < selects.length; k3++) {
	      if (selects[k3].type == 'select-one') {
	        var child = selects[k3].children;
	        for (var i in child) {
	          if (child[i].tagName == 'OPTION') {
	            if (child[i].selected == true) {
	              child[i].setAttribute('selected', "selected");
	            } else {
	              child[i].removeAttribute('selected');
	            }
	          }
	        }
	      }
	    }
	
	    return this.dom.outerHTML;
	  },
	
	  writeIframe: function writeIframe(content) {
	    var w,
	        doc,
	        iframe = document.createElement('iframe'),
	        f = document.body.appendChild(iframe);
	    iframe.id = "myIframe";
	
	    iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
	    w = f.contentWindow || f.contentDocument;
	    doc = f.contentDocument || f.contentWindow.document;
	    doc.open();
	    doc.write(content);
	    doc.close();
	    var _this = this;
	    setTimeout(function () {
	      _this.toPrint(w);
	      setTimeout(function () {
	        document.body.removeChild(iframe);
	      }, 100);
	    }, 1000);
	  },
	
	  toPrint: function toPrint(frameWindow) {
	    try {
	      setTimeout(function () {
	        frameWindow.focus();
	        try {
	          if (!frameWindow.document.execCommand('print', false, null)) {
	            frameWindow.print();
	          }
	        } catch (e) {
	          frameWindow.print();
	        }
	        frameWindow.close();
	      }, 10);
	    } catch (err) {
	      console.log('err', err);
	    }
	  },
	  isDOM: (typeof HTMLElement === 'undefined' ? 'undefined' : (0, _typeof3.default)(HTMLElement)) === 'object' ? function (obj) {
	    return obj instanceof HTMLElement;
	  } : function (obj) {
	    return obj && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
	  }
	};
	var MyPlugin = {};
	MyPlugin.install = function (Vue, options) {
	  Vue.prototype.$print = Print;
	};
	exports.default = MyPlugin;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(172);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(111);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _router = __webpack_require__(467);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _App = __webpack_require__(865);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(171);
	
	var _axios = __webpack_require__(398);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(468);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _elementUi = __webpack_require__(773);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(791);
	
	__webpack_require__(852);
	
	__webpack_require__(851);
	
	var _common = __webpack_require__(463);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _print = __webpack_require__(464);
	
	var _print2 = _interopRequireDefault(_print);
	
	var _Global = __webpack_require__(909);
	
	var _Global2 = _interopRequireDefault(_Global);
	
	var _en = __webpack_require__(776);
	
	var _en2 = _interopRequireDefault(_en);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_elementUi2.default, { locale: _en2.default });
	_vue2.default.use(_print2.default);
	
	_vue2.default.prototype.GLOBAL = _Global2.default;
	_vue2.default.prototype.common = _common2.default;
	_vue2.default.prototype.moment = _moment2.default;
	_vue2.default.prototype.$axios = _axios2.default;
	
	_axios2.default.defaults.baseURL = ("/PPMS_API");
	
	_axios2.default.interceptors.request.use(function (config) {
	  if (config.method == 'get') {
	    config.params = (0, _extends3.default)({
	      _t: Date.parse(new Date()) / 1000
	    }, config.params);
	  }
	
	  var USER_TOKEN = localStorage.getItem('token') ? localStorage.getItem('token').replace(/\"/g, "") : null;
	
	  if (USER_TOKEN && !config.url.includes('login')) {
	    config.headers.common['token'] = USER_TOKEN;
	  }
	  return config;
	}, function (err) {
	  return _promise2.default.reject(err);
	});
	
	_axios2.default.interceptors.response.use(function (response) {
	  var nowIndex = window.location.pathname;
	  if (nowIndex != '/' && (response.data.code == -1000 || response.data.msg == 'Session Expired! Please log in again!')) {
	    setTimeout(function () {
	      VueInstance.$router.push('/');
	    }, 2000);
	  }
	  return response;
	}, function (error) {
	  console.log('error', error);
	  if (error.response) {
	    switch (error.response.code) {
	      case -1000:
	        _router2.default.replace({
	          path: '/',
	          query: { redirect: _router2.default.currentRoute.fullPath }
	        });
	    }
	  }
	  return _promise2.default.reject(error.response.data);
	});
	
	var VueInstance = new _vue2.default({
	  el: '#app',
	  router: _router2.default,
	  store: _index2.default,
	
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(957);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
		mode: 'history',
		routes: [{
			path: '/',
			component: function component(resolve) {
				return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(910)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
			}
		}, {
			path: '/tscg_system',
			component: function component(resolve) {
				return __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(902)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
			},
			redirect: '/tscg_system/Index',
			children: [{
				path: '/error404',
				name: 'Error404',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(43, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(867)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'Index',
				name: 'Index',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(44, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(866)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'balanceOnHand',
				name: 'balanceOnHand',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(895)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productForecast',
				name: 'productForecast',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(898)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'salesData',
				name: 'salesData',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(900)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'itemDisplayOrder',
				name: 'itemDisplayOrder',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(897)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'balanceOnHandByTime',
				name: 'balanceOnHandByTime',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(896)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productForecastByTime',
				name: 'productForecastByTime',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(899)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'salesDataByTime',
				name: 'salesDataByTime',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(901)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'store',
				name: 'storeList',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(894)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'newStore',
				name: 'newStore',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(373)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'editStore',
				name: 'editStore',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(373)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'department',
				name: 'department',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(892)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'cluster',
				name: 'cluster',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(891)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'region',
				name: 'region',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(893)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'product',
				name: 'product',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(40, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(875)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productAdd',
				name: 'productAdd',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(876)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productEdit',
				name: 'productEdit',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(877)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'commodity',
				name: 'commodity',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(42, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(868)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'commodityAdd',
				name: 'commodityAdd',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(869)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'commodityEdit',
				name: 'commodityEdit',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(870)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productStandard',
				name: 'productStandard',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(880)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'percentageAdjust',
				name: 'percentageAdjust',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(874)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'upcomingPromotion',
				name: 'upcomingPromotion',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(37, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(881)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'configurationByTime',
				name: 'configurationByTime',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(871)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'itemLinking',
				name: 'itemLinking',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(41, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(872)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'itemLinkingEdit',
				name: 'itemLinkingEdit',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(873)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productionSchedule',
				name: 'productionSchedule',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(39, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(878)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'productScheduleAdd',
				name: 'productScheduleAdd',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(38, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(879)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'user',
				name: 'user',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(908)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'addUser',
				name: 'addUser',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(904)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'editUser',
				name: 'editUser',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(906)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'role',
				name: 'role',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(907)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'editRole',
				name: 'editRole',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(905)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'addRole',
				name: 'addRole',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(903)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'salesDataManage',
				name: 'salesDataManage',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(890)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'weeklyTotalItemMovementReport',
				name: 'weeklyTotalItemMovementReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(888)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'itemsWithoutSalesReport',
				name: 'itemsWithoutSalesReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(33, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(885)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'zeroBOHReport',
				name: 'zeroBOHReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(889)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'highBOHReport',
				name: 'highBOHReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(35, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(883)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'highDisplayStandardReport',
				name: 'highDisplayStandardReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(34, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(884)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'toolUsageReport',
				name: 'toolUsageReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(32, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(887)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'storeHeatMapReport',
				name: 'storeHeatMapReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(886)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}, {
				path: 'centralKitchenReport',
				name: 'centralKitchenReport',
				component: function component(resolve) {
					return __webpack_require__.e/* require */(36, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(882)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
				}
			}]
		}]
	});
	
	router.beforeEach(function (to, from, next) {
		if (to.matched.length === 0) {
			from.name ? next({
				name: from.name
			}) : next('/error404');
		} else {
			next();
		}
	});
	
	exports.default = router;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(958);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  state: {
	    showRegister: true
	  },
	  getters: {},
	  mutations: {
	    changeHeader: function changeHeader(state) {
	      if (state.showRegister) {
	        state.showRegister = false;
	      } else {
	        state.showRegister = true;
	      }
	    }
	  }
	});
	exports.default = store;

/***/ }),

/***/ 791:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 804:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 851:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 234,
		"./af.js": 234,
		"./ar": 242,
		"./ar-dz": 235,
		"./ar-dz.js": 235,
		"./ar-kw": 236,
		"./ar-kw.js": 236,
		"./ar-ly": 237,
		"./ar-ly.js": 237,
		"./ar-ma": 238,
		"./ar-ma.js": 238,
		"./ar-ps": 239,
		"./ar-ps.js": 239,
		"./ar-sa": 240,
		"./ar-sa.js": 240,
		"./ar-tn": 241,
		"./ar-tn.js": 241,
		"./ar.js": 242,
		"./az": 243,
		"./az.js": 243,
		"./be": 244,
		"./be.js": 244,
		"./bg": 245,
		"./bg.js": 245,
		"./bm": 246,
		"./bm.js": 246,
		"./bn": 248,
		"./bn-bd": 247,
		"./bn-bd.js": 247,
		"./bn.js": 248,
		"./bo": 249,
		"./bo.js": 249,
		"./br": 250,
		"./br.js": 250,
		"./bs": 251,
		"./bs.js": 251,
		"./ca": 252,
		"./ca.js": 252,
		"./cs": 253,
		"./cs.js": 253,
		"./cv": 254,
		"./cv.js": 254,
		"./cy": 255,
		"./cy.js": 255,
		"./da": 256,
		"./da.js": 256,
		"./de": 259,
		"./de-at": 257,
		"./de-at.js": 257,
		"./de-ch": 258,
		"./de-ch.js": 258,
		"./de.js": 259,
		"./dv": 260,
		"./dv.js": 260,
		"./el": 261,
		"./el.js": 261,
		"./en-au": 262,
		"./en-au.js": 262,
		"./en-ca": 263,
		"./en-ca.js": 263,
		"./en-gb": 264,
		"./en-gb.js": 264,
		"./en-ie": 265,
		"./en-ie.js": 265,
		"./en-il": 266,
		"./en-il.js": 266,
		"./en-in": 267,
		"./en-in.js": 267,
		"./en-nz": 268,
		"./en-nz.js": 268,
		"./en-sg": 269,
		"./en-sg.js": 269,
		"./eo": 270,
		"./eo.js": 270,
		"./es": 274,
		"./es-do": 271,
		"./es-do.js": 271,
		"./es-mx": 272,
		"./es-mx.js": 272,
		"./es-us": 273,
		"./es-us.js": 273,
		"./es.js": 274,
		"./et": 275,
		"./et.js": 275,
		"./eu": 276,
		"./eu.js": 276,
		"./fa": 277,
		"./fa.js": 277,
		"./fi": 278,
		"./fi.js": 278,
		"./fil": 279,
		"./fil.js": 279,
		"./fo": 280,
		"./fo.js": 280,
		"./fr": 283,
		"./fr-ca": 281,
		"./fr-ca.js": 281,
		"./fr-ch": 282,
		"./fr-ch.js": 282,
		"./fr.js": 283,
		"./fy": 284,
		"./fy.js": 284,
		"./ga": 285,
		"./ga.js": 285,
		"./gd": 286,
		"./gd.js": 286,
		"./gl": 287,
		"./gl.js": 287,
		"./gom-deva": 288,
		"./gom-deva.js": 288,
		"./gom-latn": 289,
		"./gom-latn.js": 289,
		"./gu": 290,
		"./gu.js": 290,
		"./he": 291,
		"./he.js": 291,
		"./hi": 292,
		"./hi.js": 292,
		"./hr": 293,
		"./hr.js": 293,
		"./hu": 294,
		"./hu.js": 294,
		"./hy-am": 295,
		"./hy-am.js": 295,
		"./id": 296,
		"./id.js": 296,
		"./is": 297,
		"./is.js": 297,
		"./it": 299,
		"./it-ch": 298,
		"./it-ch.js": 298,
		"./it.js": 299,
		"./ja": 300,
		"./ja.js": 300,
		"./jv": 301,
		"./jv.js": 301,
		"./ka": 302,
		"./ka.js": 302,
		"./kk": 303,
		"./kk.js": 303,
		"./km": 304,
		"./km.js": 304,
		"./kn": 305,
		"./kn.js": 305,
		"./ko": 306,
		"./ko.js": 306,
		"./ku": 308,
		"./ku-kmr": 307,
		"./ku-kmr.js": 307,
		"./ku.js": 308,
		"./ky": 309,
		"./ky.js": 309,
		"./lb": 310,
		"./lb.js": 310,
		"./lo": 311,
		"./lo.js": 311,
		"./lt": 312,
		"./lt.js": 312,
		"./lv": 313,
		"./lv.js": 313,
		"./me": 314,
		"./me.js": 314,
		"./mi": 315,
		"./mi.js": 315,
		"./mk": 316,
		"./mk.js": 316,
		"./ml": 317,
		"./ml.js": 317,
		"./mn": 318,
		"./mn.js": 318,
		"./mr": 319,
		"./mr.js": 319,
		"./ms": 321,
		"./ms-my": 320,
		"./ms-my.js": 320,
		"./ms.js": 321,
		"./mt": 322,
		"./mt.js": 322,
		"./my": 323,
		"./my.js": 323,
		"./nb": 324,
		"./nb.js": 324,
		"./ne": 325,
		"./ne.js": 325,
		"./nl": 327,
		"./nl-be": 326,
		"./nl-be.js": 326,
		"./nl.js": 327,
		"./nn": 328,
		"./nn.js": 328,
		"./oc-lnc": 329,
		"./oc-lnc.js": 329,
		"./pa-in": 330,
		"./pa-in.js": 330,
		"./pl": 331,
		"./pl.js": 331,
		"./pt": 333,
		"./pt-br": 332,
		"./pt-br.js": 332,
		"./pt.js": 333,
		"./ro": 334,
		"./ro.js": 334,
		"./ru": 335,
		"./ru.js": 335,
		"./sd": 336,
		"./sd.js": 336,
		"./se": 337,
		"./se.js": 337,
		"./si": 338,
		"./si.js": 338,
		"./sk": 339,
		"./sk.js": 339,
		"./sl": 340,
		"./sl.js": 340,
		"./sq": 341,
		"./sq.js": 341,
		"./sr": 343,
		"./sr-cyrl": 342,
		"./sr-cyrl.js": 342,
		"./sr.js": 343,
		"./ss": 344,
		"./ss.js": 344,
		"./sv": 345,
		"./sv.js": 345,
		"./sw": 346,
		"./sw.js": 346,
		"./ta": 347,
		"./ta.js": 347,
		"./te": 348,
		"./te.js": 348,
		"./tet": 349,
		"./tet.js": 349,
		"./tg": 350,
		"./tg.js": 350,
		"./th": 351,
		"./th.js": 351,
		"./tk": 352,
		"./tk.js": 352,
		"./tl-ph": 353,
		"./tl-ph.js": 353,
		"./tlh": 354,
		"./tlh.js": 354,
		"./tr": 355,
		"./tr.js": 355,
		"./tzl": 356,
		"./tzl.js": 356,
		"./tzm": 358,
		"./tzm-latn": 357,
		"./tzm-latn.js": 357,
		"./tzm.js": 358,
		"./ug-cn": 359,
		"./ug-cn.js": 359,
		"./uk": 360,
		"./uk.js": 360,
		"./ur": 361,
		"./ur.js": 361,
		"./uz": 363,
		"./uz-latn": 362,
		"./uz-latn.js": 362,
		"./uz.js": 363,
		"./vi": 364,
		"./vi.js": 364,
		"./x-pseudo": 365,
		"./x-pseudo.js": 365,
		"./yo": 366,
		"./yo.js": 366,
		"./zh-cn": 367,
		"./zh-cn.js": 367,
		"./zh-hk": 368,
		"./zh-hk.js": 368,
		"./zh-mo": 369,
		"./zh-mo.js": 369,
		"./zh-tw": 370,
		"./zh-tw.js": 370
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 854;


/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(804)
	
	/* script */
	__vue_exports__ = __webpack_require__(415)
	
	/* template */
	var __vue_template__ = __webpack_require__(920)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(460)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	
	module.exports = __vue_exports__


/***/ }),

/***/ 920:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.935ba2cdf0a5262c408a.js